import { jsx as i, jsxs as u } from "react/jsx-runtime";
import { c as x } from "./clsx-OuTLNxxd.js";
import { I as L } from "./icon-BnqXyiyH.js";
import "./components/elements/icon/iconsList.js";
const g = "_link_hil43_29", s = {
  link: g,
  "is-primary": "_is-primary_hil43_37",
  "is-secondary": "_is-secondary_hil43_43",
  "is-inverted": "_is-inverted_hil43_49",
  "is-underlined": "_is-underlined_hil43_55",
  "is-disabled": "_is-disabled_hil43_68",
  "link-external": "_link-external_hil43_77",
  "dialog-overlay-show": "_dialog-overlay-show_hil43_1",
  "dialog-content-show": "_dialog-content-show_hil43_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_hil43_1"
}, v = {
  primary: "is-primary",
  secondary: "is-secondary",
  inverted: "is-inverted"
};
function j({
  color: p = "primary",
  children: n,
  href: o,
  target: _,
  disabled: a,
  Component: c,
  className: y,
  noUnderline: h = !1,
  external: k,
  ariaLabel: d,
  onClick: r,
  ...e
}) {
  const l = x(
    s.link,
    s[v[p]],
    a && s["is-disabled"],
    !h && s["is-underlined"],
    y
  ), t = /* @__PURE__ */ i("span", { className: l, ...e, children: n });
  if (c)
    return a ? t : /* @__PURE__ */ i(c, { onClick: r, className: l, href: o, target: _, "aria-label": d, ...e, children: n });
  if (!o)
    return a ? t : /* @__PURE__ */ i("button", { onClick: r, className: l, ...e, children: n });
  const m = /* @__PURE__ */ i(
    "a",
    {
      onClick: r,
      href: o,
      target: _,
      className: l,
      "aria-label": d,
      ...e,
      children: n
    }
  );
  return a ? t : k ? /* @__PURE__ */ u("span", { className: s["link-external"], children: [
    m,
    /* @__PURE__ */ i(L, { name: "new-tab", size: "large" })
  ] }) : m;
}
export {
  j as L,
  s
};
